import { Asset } from "../shared/models/assets.model";
import { Comment } from "../shared/models/comment.model";
import { Template } from "../shared/models/templates.model";
import { todoCategory } from "../shared/models/todoCategory.model";
import { proxy } from "valtio";

export interface ITodoState {
	todos: todoCategory[];
	templateSelected: Template;
	comments: Comment[];
	commentSelected: Comment;
	currentAssets: Asset[];
	showAttachmentsViewer: boolean;
	currentAttachment: Asset;
}

export const todoStore = proxy({
	templateSelected: {
		id: '',
		name: '',
		description: ''
	},
	todos:  new todoCategory(),
	comments:[] as Comment[],
	commentSelected: new Comment,
	currentAssets: [] as Asset[],
	showAttachmentsViewer: false,
	currentAttachment: new Asset,
	setTodosAction: (value: todoCategory) => {
		todoStore.todos = value;
	},
	selectTemplateAction: (value: Template) => {
		todoStore.templateSelected = value;
	},
	setCommentsAction: (value: Comment[]) => {
		todoStore.comments = value;
	},
	selectCommentAction: (value: Comment) => {
		todoStore.commentSelected = value;
	},
	addAssetAction: (value: Asset) => {
		todoStore.currentAssets.push(value);
	},
	clearAssetsAction: () => {
		todoStore.currentAssets = [];
	},
	deleteAssetAction: (value: Asset) => {
		todoStore.currentAssets = todoStore.currentAssets.filter((asset:Asset)=> asset.id != value.id)
	},
	showAttachmentsViewerAction: (value: boolean) => {
		todoStore.showAttachmentsViewer = value;
	},
	setCurrentAttachmentAction: (value: Asset) => {
		todoStore.currentAttachment = value;
	}
})
